/* Components */
import getLayout from '@scenes/HomeHub/HomeHub.Layout';
import UserInformationSurvey from '@scenes/HomeHub/pages/User';

/* Constants */
import { PAGE_TYPE_USER_HUB_SURVEYS } from '@constants/pages';

/**
 * This is the user flow, not really a survey.
 *
 * Usually, you'd just insert everything here, but there is a lot of code, and we
 * want to keep architecture to mimic [surveyType].tsx, since they sit in the same place.
 *
 * @returns {JSX.Element}
 * @constructor
 */

const UserSurveyPage = () => <UserInformationSurvey />;

export default UserSurveyPage;

UserSurveyPage.pageAttributes = { page: PAGE_TYPE_USER_HUB_SURVEYS };
UserSurveyPage.Layout = getLayout({ suppressFooter: true });
